import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { CardStack, Checkbox } from '@pearsontechnology/aero-components';

import summaryShape from 'Workspace/types/pluginSummary';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import { commandWorkspacePluginUpdate } from 'containers/ConnectionManager/actions';

import messages from './messages';
import { PluginSettingsWrapper, CheckboxWrapper } from './styles';

const PluginSettingsCard = ({ summary, updatePluginPublish }) => {
  const handleCheckboxChange = (event) => {
    const publishMode = event.target.checked ? 'STRICT' : 'DEFAULT';
    updatePluginPublish(summary.pluginId, publishMode);
  };

  return (
    <CardStack
      icon="settings"
      title={intl.formatMessage(messages.pluginSettingsTitle)}
    >
      <PluginSettingsWrapper>
        {intl.formatMessage(messages.pluginSettingsPublishModeTitle)}
        <CheckboxWrapper>
          { summary && <Checkbox checked={summary.publishMode === 'STRICT'} isSwitch onChange={handleCheckboxChange} />}
        </CheckboxWrapper>
      </PluginSettingsWrapper>
    </CardStack>
  );
};

PluginSettingsCard.propTypes = {
  summary: summaryShape,
  updatePluginPublish: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => ({
  updatePluginPublish: (pluginId, publishMode) => dispatch(commandWorkspacePluginUpdate(pluginId, publishMode)),
});

export default connect(null, mapDispatchToProps)(PluginSettingsCard);
